export default "__VITE_PUBLIC_ASSET__432d19dd__"